import { useLayoutEffect, useMemo, useRef, useState } from 'react'

// Dimensions returned by the existing Revive zones.
const zoneSizes = { 1: [728, 90], 2: [728, 90], 3: [970, 90], 13: [300, 250] } as const

interface ReviveAdZoneProps { zoneId: keyof typeof zoneSizes }

export function ReviveAdZone({ zoneId }: ReviveAdZoneProps) {
  const [width, height] = zoneSizes[zoneId]
  const container = useRef<HTMLDivElement>(null)
  const [availableWidth, setAvailableWidth] = useState(width as number)
  const scale = Math.min(1, availableWidth / width)
  const src = useMemo(() => {
    const url = new URL('https://adserver.eltelegrafo.com.ec/www/delivery/ajs.php')
    url.searchParams.set('zoneid', String(zoneId))
    url.searchParams.set('cb', `${Date.now()}-${Math.random().toString(36).slice(2)}`)
    url.searchParams.set('loc', window.location.href)
    return url.href
  }, [zoneId])
  // Revive's standard JS tag runs inside its own document: document.write cannot
  // replace the React page, and a slow ad never blocks the application's scripts.
  const adDocument = `<!doctype html><html><head><meta charset="utf-8"><meta name="referrer" content="no-referrer"><style>html,body{margin:0;padding:0;overflow:hidden;background:transparent}img{border:0}</style></head><body><script src="${src.replace(/&/g, '&amp;')}"></script></body></html>`

  useLayoutEffect(() => {
    const element = container.current!
    const update = () => setAvailableWidth(element.getBoundingClientRect().width)
    update()
    const observer = new ResizeObserver(update)
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={container} className="ad-slot ad-slot--iframe" style={{ maxWidth: width, aspectRatio: `${width} / ${height}` }}>
      <iframe
        title={`Publicidad — zona ${zoneId}`}
        srcDoc={adDocument}
        width={width}
        height={height}
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
        scrolling="no"
        style={{ width, height, transform: `scale(${scale})` }}
      />
    </div>
  )
}
